<template>
    <div v-loading="isLoading">
        <h3 class="search-title">
            <i class="el-icon-search"></i> 기간 선택
            <el-date-picker v-model="filter.month"
                            type="month"
                            class="month-picker"
                            placeholder="월을 선택해주세요."
                            :clearable="false"
                            @change="getOrderList"/>
        </h3>

        <el-row v-if="orderStatus"
                :gutter="22">
            <el-col :span="6">
                <el-card class="statistics-card statistics-card--primary">
                    <h1>{{monthText}} 현황</h1>
                    <ul>
                        <li>
                            <span class="label">총 발주액</span>
                            <span class="value">{{totalStatus.totalPrice | numberWithComma}} 원</span>
                        </li>
                        <li>
                            <span class="label">총 발주 건수</span>
                            <span class="value">{{totalStatus.count | numberWithComma}} 건</span>
                        </li>
                        <li>
                            <span class="label">총 의류 수량</span>
                            <span class="value">{{totalStatus.amount | numberWithComma}} 벌</span>
                        </li>
                    </ul>
                </el-card>
            </el-col>
            <el-col :span="6">
                <el-card class="statistics-card statistics-card--success">
                    <h1>발주 완료</h1>
                    <ul>
                        <li>
                            <span class="label">완료 총액</span>
                            <span class="value">{{successStatus.totalPrice | numberWithComma}} 원</span>
                        </li>
                        <li>
                            <span class="label">완료 건수</span>
                            <span class="value">{{successStatus.count | numberWithComma}} 건</span>
                        </li>
                        <li>
                            <span class="label">의류 수량</span>
                            <span class="value">{{successStatus.amount | numberWithComma}} 벌</span>
                        </li>
                    </ul>
                </el-card>
            </el-col>
            <el-col :span="6">
                <el-card class="statistics-card statistics-card--info">
                    <h1>대기</h1>
                    <ul>
                        <li>
                            <span class="label">대기 총액</span>
                            <span class="value">{{waitStatus.totalPrice | numberWithComma}} 원</span>
                        </li>
                        <li>
                            <span class="label">대기 건수</span>
                            <span class="value">{{waitStatus.count | numberWithComma}} 건</span>
                        </li>
                        <li>
                            <span class="label">의류 수량</span>
                            <span class="value">{{waitStatus.amount | numberWithComma}} 벌</span>
                        </li>
                    </ul>
                </el-card>
            </el-col>
            <el-col :span="6">
                <el-card class="statistics-card statistics-card--danger">
                    <h1>취소</h1>
                    <ul>
                        <li>
                            <span class="label">취소 건수</span>
                            <span class="value">{{failStatus.count | numberWithComma}} 건</span>
                        </li>
                    </ul>
                </el-card>
            </el-col>
        </el-row>

        <el-card class="dashboard-card"
                 v-loading="isLoading2">
            <div slot="header">
                <el-row>
                    <el-col :span="8">
                        <h3 class="cart-title"><i class="el-icon-s-order"></i> {{monthText}} 발주 리스트</h3>
                    </el-col>
                    <el-col :span="16"
                            align="right">
                        <el-button type="primary"
                                   @click.prevent="openCreateOrderModal">
                            <i class="el-icon-plus"></i> {{monthText}} 발주 추가
                        </el-button>
                    </el-col>
                </el-row>
            </div>
            <el-table :data="orderList"
                      border
                      stripe
                      @filter-change="filterHandler">
                <el-table-column header-align="center"
                                 align="center"
                                 width="320">
                    <template slot="header">
                        발주ID<br/><span style="color: #F56C6C">작품ID</span>
                    </template>
                    <template slot-scope="scope">
                        <el-tag type="info"
                                size="mini"
                                class="font--consolas"
                                effect="plain">{{scope.row.partnerOrderId}}
                        </el-tag>
                        <br/>
                        <el-tag type="danger"
                                size="mini"
                                class="font--consolas"
                                effect="plain">{{scope.row.artId}}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="총 금액"
                                 header-align="center"
                                 align="right"
                                 width="160">
                    <template slot-scope="scope">
                        {{scope.row.totalPrice | numberWithComma}}원
                    </template>
                </el-table-column>
                <el-table-column label="발주 상태"
                                 header-align="center"
                                 align="center"
                                 width="140"
                                 :filters="orderStateFilterList"
                                 column-key="orderStateList">
                    <template slot-scope="scope">
                        <OrderStateTag :orderState="scope.row.orderState"/>
                    </template>
                </el-table-column>
                <el-table-column label="주문 상세"
                                 header-align="center"
                                 align="right"
                                 min-width="500">
                    <template slot-scope="scope">
                        <ul>
                            <li v-for="(orderItem, index) in scope.row.orderItemList"
                                :key="index"
                                class="order-item">
                                <span class="area--size">
                                    <el-tag type="warning"
                                            effect="plain">{{orderItem.sizeName}}
                                    </el-tag>
                                </span>
                                <span class="area--amount">
                                    {{orderItem.amount}}개
                                </span>
                                <span class="area--price">
                                    {{orderItem.price | numberWithComma}}원
                                </span>
                            </li>
                        </ul>
                    </template>
                </el-table-column>
                <el-table-column label="관리"
                                 header-align="center"
                                 align="center"
                                 fixed="right"
                                 width="160">
                    <template slot-scope="scope">
                        <el-button type="primary"
                                   @click.prevent="openArtDetail(scope.row.artId)">작품 정보보기
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <p class="desc--info">발주 진행 단계
                <i class="el-icon-caret-right"></i>
                <OrderStateTag :orderState="ORDER_STATE.WAITING"/>
                <i class="el-icon-right"></i>
                <OrderStateTag :orderState="ORDER_STATE.RESOLVE"/>
                <i class="el-icon-right"></i>
                <OrderStateTag :orderState="ORDER_STATE.SHIPPING"/>
                <i class="el-icon-right"></i>
                <OrderStateTag :orderState="ORDER_STATE.COMPLETE"/>
                <br/>
                발주 취소 상태
                <i class="el-icon-caret-right"></i>
                <OrderStateTag :orderState="ORDER_STATE.REJECT"/>
                <i>/</i>
                <OrderStateTag :orderState="ORDER_STATE.CANCEL"/>
            </p>
        </el-card>

        <Cafe24CreateOrderModal v-if="isShowCreateOrderModal"
                                @apply="getOrderList"
                                @close="closeCreateOrder"/>

        <Cafe24ArtDetailModal v-if="selectedArt"
                              :art="selectedArt"
                              @close="closeArtDetail"/>
    </div>
</template>

<script>
    import {RepositoryFactory} from '@/repositories/RepositoryFactory';
    import {ORDER_STATE} from '@/const';
    import OrderStateTag from '@/components/OrderStateTag';
    import Cafe24ArtDetailModal from '@/components/cafe24/Cafe24ArtDetailModal';
    import Cafe24CreateOrderModal from '@/components/cafe24/Cafe24CreateOrderModal';

    const PrintingDiyRepository = RepositoryFactory.get('printingDiy');

    export default {
        name: 'Cafe24OrderList',
        components: {Cafe24CreateOrderModal, Cafe24ArtDetailModal, OrderStateTag},
        data() {
            return {
                ORDER_STATE,

                isLoading: false,
                isLoading2: false,

                filter: {
                    month: new Date(),
                    orderStateList: [],
                },
                totalCount: 0,
                orderList: [],
                orderStatus: null,
                orderStateFilterList: [
                    {text: '대기중', value: ORDER_STATE.WAITING},
                    {text: '취소됨', value: ORDER_STATE.CANCEL},
                    {text: '거절됨', value: ORDER_STATE.REJECT},
                    {text: '제작중', value: ORDER_STATE.RESOLVE},
                    {text: '배송중', value: ORDER_STATE.SHIPPING},
                    {text: '배송완료', value: ORDER_STATE.COMPLETE},
                ],

                isShowCreateOrderModal: false,

                selectedArt: null,
            };
        },
        computed: {
            mall() {
                return this.$store.state.cafe24.mall;
            },
            authToken() {
                return this.$store.state.auth.authToken;
            },
            monthText() {
                return `${this.filter.month.getMonth() + 1}월`;
            },

            totalStatus() {
                return this.mergeOrderStateStatus([ORDER_STATE.WAITING, ORDER_STATE.RESOLVE, ORDER_STATE.SHIPPING, ORDER_STATE.COMPLETE]);
            },
            successStatus() {
                return this.mergeOrderStateStatus([ORDER_STATE.RESOLVE, ORDER_STATE.SHIPPING, ORDER_STATE.COMPLETE]);
            },
            waitStatus() {
                return this.mergeOrderStateStatus([ORDER_STATE.WAITING]);
            },
            failStatus() {
                return this.mergeOrderStateStatus([ORDER_STATE.CANCEL, ORDER_STATE.REJECT]);
            },
        },
        methods: {
            async getOrderList() {
                try {
                    this.isShowCreateOrderModal = false;
                    this.isLoading = true;
                    const startDate = new Date(this.filter.month.getFullYear(), this.filter.month.getMonth(), 1);
                    const endDate = new Date(this.filter.month.getFullYear(), this.filter.month.getMonth() + 1, 0, 23, 59, 59, 999);
                    const orderStateList = this.filter.orderStateList.length > 0 ? this.filter.orderStateList : [ORDER_STATE.WAITING, ORDER_STATE.CANCEL, ORDER_STATE.COMPLETE, ORDER_STATE.REJECT, ORDER_STATE.RESOLVE, ORDER_STATE.SHIPPING];

                    const {data} = await PrintingDiyRepository.getPartnerOrderList(this.mall.mallId, orderStateList, startDate, endDate, this.authToken);
                    this.totalCount = data.totalCount;
                    this.orderList = data.list;
                    this.orderStatus = data.status;
                } catch (e) {
                    this.$message.error(e.message);
                } finally {
                    this.isLoading = false;
                }
            },
            async getArt(artId) {
                try {
                    this.isLoading2 = true;
                    const {data: art} = await PrintingDiyRepository.getPartnerArt(this.mall.mallId, artId, this.authToken);
                    return art;
                } catch (e) {
                    this.$message.error(e.message);
                } finally {
                    this.isLoading2 = false;
                }
            },

            filterHandler({orderStateList}) {
                this.filter.orderStateList = orderStateList;
                this.getOrderList();
            },

            openCreateOrderModal() {
                this.isShowCreateOrderModal = true;
            },

            async openArtDetail(artId) {
                this.selectedArt = await this.getArt(artId);
            },

            async closeCreateOrder() {
                this.isShowCreateOrderModal = false;
            },

            closeArtDetail() {
                this.selectedArt = null;
            },

            mergeOrderStateStatus(orderStateList) {
                return orderStateList.reduce((acc, item) => {
                    const status = this.orderStatus[item];
                    acc.count += (+status.count);
                    acc.amount += (+status.amount);
                    acc.totalPrice += (+status.totalPrice);

                    return acc;
                }, {
                    count: 0,
                    amount: 0,
                    totalPrice: 0,
                });
            },
        },
        async created() {
            await this.getOrderList();
        },
    };
</script>

<style lang="scss" scoped>
    .search-title {
        margin: 30px 10px;
        font-size: 22px;
        text-align: center;

        .month-picker {
            display: inline-block;
            margin-left: 20px;
            width: 160px !important;
        }
    }

    .statistics-card {
        min-height: 250px;
        color: #fff;

        h1 {
            font-size: 26px;
            line-height: 38px;
            margin-bottom: 60px;
        }

        &.statistics-card--primary {
            background-color: #409EFF;

            h1 {
                font-size: 38px;
            }
        }

        &.statistics-card--success {
            background-color: #67C23A;
        }

        &.statistics-card--info {
            background-color: #909399;
        }

        &.statistics-card--danger {
            background-color: #F56C6C;
        }

        ul {
            width: 100%;

            li {
                line-height: 34px;
                text-align: right;

                .label {
                    display: inline-block;
                    font-size: 16px;
                    width: 120px;
                }

                .value {
                    display: inline-block;
                    width: 180px;
                    font-size: 22px;
                    font-weight: bold;
                }
            }
        }
    }

    .desc--info {
        padding: 20px;
        margin-top: 40px;
        background-color: #f1f1f1;
        font-size: 14px;
        line-height: 42px;

        i {
            margin: 0 10px;
        }
    }

    .order-item {
        width: 100%;
        border-bottom: 1px dashed #ddd;
        padding: 10px;

        &:last-child {
            border-bottom: 0;
        }

        .area--size {
            display: inline-block;
            width: 250px;
        }

        .area--amount {
            display: inline-block;
            width: 80px;
        }

        .area--price {
            display: inline-block;
            width: 120px;
        }
    }
</style>